module.exports = __webpack_public_path__ + "static/image/logo-family/logo_taste.png?93de9ec0";